import { apiV2 } from '../http';

export const chooseBillingMethod = (companyId, billingMethodId) =>
  apiV2.post(`/company/${companyId}/billing-methods/${billingMethodId}`);

export const updateBillingMethod = (companyId, billingMethodId) =>
  apiV2.patch(`/company/${companyId}/billing-methods/${billingMethodId}`);

export const getCompanyCurrentBillingMethod = companyId =>
  apiV2.get(`/company/${companyId}/billing-methods`);

export const updateCompanyBillingMethodStatus = billingMethodId =>
  apiV2.patch(`/company/${billingMethodId}/change-status`);

/**
 * Gera link de pagamento para a empresa.
 * @param {{ companyId: number } | number} payload - Objeto com companyId ou ID numérico
 * @returns {Promise<{ data?: string | { url?: string } }>} Resposta com URL (string ou objeto com url)
 */
export const chargePayment = payload => {
  const companyId = typeof payload === 'object' && payload !== null ? payload.companyId : payload;
  return apiV2.post(`/charge-payment`, { data: { companyId } });
};

export const getCompanyCredits = companyId => apiV2.get(`/credits/${companyId}`);
